import { mapGetters } from 'vuex';
import { isNil } from 'lodash';

export default {
  computed: {
    ...mapGetters([
      'getRouteQuery',
    ]),

    isBrowserView() {
      return isNil(this.getRouteQuery.source);
    },

    isDesktop() {
      return this.isBrowserView || !this.$mobile.isMobile();
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/desktop.js